import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Actions from "../../../components/Actions";
import Loader from "../../../components/Loader";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";

const Panel = ({ setVisiblePreview, isLoading, Submit, reqBody }) => {
	const actions = [
		{
			title: "Preview",
			icon: "expand",
			action: () => setVisiblePreview(true),
		},
	];

	const ButtonHandler = () => {
		if (reqBody.name === "" || reqBody.image === "") {
			ToastEmitter({
				type: "info",
				msg: "Your draft must has atleast title and image",
			});
		} else {
			Submit({ isDraft: true });
		}
	};

	return (
		<div className={cn("panel", styles.panel)}>
			<div className={styles.info}></div>
			<div className={styles.btns}>
				<button
					className={cn(
						`button-stroke ${isLoading ? "disabled" : ""}`,
						styles.button
					)}
					onClick={ButtonHandler}
					type="button"
				>
					{isLoading && <Loader />}
					Save Draft
				</button>
				<button type="submit" className={cn("button", styles.button)}>
					Publish
				</button>
				<Actions
					className={styles.actions}
					classActionsHead={styles.actionsHead}
					classActionsBody={styles.actionsBody}
					classActionsOption={styles.actionsOption}
					items={actions}
					up
				/>
			</div>
		</div>
	);
};

export default Panel;
